/* eslint-disable complexity */
import React from 'react';

import Button from '@atlaskit/button';

import {
  DetailsRow,
  DetailsRowValueStyledSpan,
} from '@qality/common-components/src/atoms/DetailsRow';
import { ExecutionStatus } from '@qality/common-model';

import { ExecutionStatusLozenge } from '../../atoms/ExecutionStatusLozenge';
import { TextExecutionDetailsHistory } from './TextExecutionDetailsHistory';

type Props = {
  executionsCount: number;
  executionsHistoryUrl: string;
  previousExecutionStatus: ExecutionStatus;
  previousExecution: string;
  previousExecutionUrl: string;
  lastFailedExectution: string;
};

export const TextExecutionDetailsView = ({
  executionsCount,
  executionsHistoryUrl,
  previousExecutionStatus,
  previousExecution,
  previousExecutionUrl,
  lastFailedExectution,
}: Props): JSX.Element => {
  return (
    <>
      <TextExecutionDetailsHistory
        executionsCount={executionsCount}
        executionsHistoryUrl={executionsHistoryUrl}
      />
      {previousExecution && (
        <DetailsRow>
          <DetailsRow.Label>Previous execution:</DetailsRow.Label>
          <DetailsRow.Value>
            <Button
              appearance='link'
              href={previousExecutionUrl}
              target='_BLANK'
            >
              {previousExecution}
            </Button>
            {previousExecutionStatus && (
              <ExecutionStatusLozenge status={previousExecutionStatus} />
            )}
          </DetailsRow.Value>
        </DetailsRow>
      )}
      {lastFailedExectution && (
        <DetailsRow>
          <DetailsRow.Label>Last FAILED:</DetailsRow.Label>
          <DetailsRow.Value>
            <DetailsRowValueStyledSpan>
              {lastFailedExectution}
            </DetailsRowValueStyledSpan>
          </DetailsRow.Value>
        </DetailsRow>
      )}
    </>
  );
};
